<template>
  <div class="home">
    <h1 class="title">Welcome to Lotto Voraz</h1>
  </div>
</template>

<script>
// @ is an alias to /src
// example: import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HomeView",
};
</script>

<style scoped>
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f0f0;
}
.title {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10vmax;
  font-weight: bold;
  text-transform: uppercase;
  margin-left: 1rem;
}
</style>
